import { LoadingOverlay, Stack } from '@mantine/core';
import type { MantineSpacing } from '@mantine/core';

import classes from './full-main-height.module.css';

interface FullMainHeightRootProps {
  children: React.ReactNode;
  gap?: MantineSpacing;
  loading?: boolean;
}

export const FullMainHeightRoot = ({
  children,
  gap = 'md',
  loading,
}: FullMainHeightRootProps) => {
  return (
    <div className={classes.root}>
      <LoadingOverlay visible={loading} />
      <Stack className={classes.stack} gap={gap} h="100%">
        {children}
      </Stack>
    </div>
  );
};
